// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorBoundary-module__wrapper--b246b","error":"ErrorBoundary-module__error--c001e","resetLink":"ErrorBoundary-module__resetLink--ad2b7"};